/** Roles allowed to view/print GSEC settlement instruction letters. */
export const GSEC_LETTER_ROLES = ['back_office_verifier', 'back_office_final', 'admin'];

export function isGsecFinalApproved(tx) {
  if (!tx) return false;
  return String(tx.status || '').toLowerCase() === 'final_approved';
}

/**
 * Settlement letters are only for fully approved deals and back-office authorizers (+ admin).
 */
export function canGenerateGsecLetter(user, tx) {
  if (!user || !tx) return false;
  if (!GSEC_LETTER_ROLES.includes(user.role)) return false;
  return isGsecFinalApproved(tx);
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
}
